module.exports = __webpack_public_path__ + "img/shi_wang_xi_shou_ye.e7cf7c86.png";